import {NodeProps} from "@xyflow/react";
import {LlmNode} from "@/view/workflow/components/workflowGraph/types";
import OperatorNodeBase from "@/view/workflow/components/workflowGraph/node/OperatorNodeBase";

const LlmOperatorNode = (props: NodeProps<LlmNode>)=> {
    const {data} = props;
    const {model} = data;

    return (
        <OperatorNodeBase {...props}>
            <div className="mt-2 flex flex-col text-xs gap-1.5">
                <div className="flex items-center gap-2">
                    <span className="w-14 shrink-0 uppercase tracking-wide text-muted-foreground">
                        Provider
                    </span>
                    <span className="rounded bg-muted/50 px-2 py-0.5 font-medium">
                        {model.vendor}
                    </span>
                </div>
                <div className="flex items-center gap-2">
                    <span className="w-14 shrink-0 uppercase tracking-wide text-muted-foreground">
                        Model
                    </span>
                    <span className="rounded bg-blue-50 px-2 py-0.5 font-medium text-blue-700" title={model.model}>
                        {model.model}
                    </span>
                </div>
            </div>
        </OperatorNodeBase>
    )
}

export default LlmOperatorNode;